import { render, staticRenderFns } from "./WUserSignupTwo.vue?vue&type=template&id=01fbd168&"
import script from "./WUserSignupTwo.vue?vue&type=script&lang=ts&"
export * from "./WUserSignupTwo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports